import React from 'react';
import { Form, FormCheckProps } from 'react-bootstrap';
import { useRadioGroup } from './RadioGroupContext';

export type RadioProps = FormCheckProps & {
  name?: string;
  label?: string;
  value: string | number;
  className?: string;
  onChange?: (value: string | number) => void;
    isRadioButton?: boolean;
  };

const Radio: React.FC<RadioProps> = ({
  name: nameProp,
  label,
  disabled,
  defaultChecked: checkedProp,
  value,
  className,
  onChange,
  onMouseDown,
  isRadioButton = false,
  ...props
}: RadioProps) => {
  const groupContext = useRadioGroup();
  let name = nameProp;
  let checked = checkedProp;

  const handleOnMouseDown = (event: React.MouseEvent<HTMLInputElement>) => {
    onMouseDown && onMouseDown(event);
  };

  const handleOnChange = () => {
    if (!disabled) {
      if (groupContext.onChange) groupContext.onChange(value);
      else if (onChange) onChange(value);
    }
  };

  if (groupContext) {
    if (typeof checked === 'undefined') {
      checked = groupContext.value === value;
    }
    if (typeof name === 'undefined') {
      name = groupContext.name;
    }
  }

  return (
    <Form.Check
      type={'radio'}
      {...props}
      className={`${className} radio-custom ${
        isRadioButton ? 'radio-button' : ''
      } ${isRadioButton && checked ? 'radio-button--checked' : ''} `}
    >
      <Form.Check.Input
        onChange={handleOnChange}
        type={'radio'}
        name={name}
        disabled={disabled}
        checked={checked}
        value={value}
        onMouseDown={handleOnMouseDown}
      />
      {label && <Form.Check.Label>{label}</Form.Check.Label>}
    </Form.Check>
  );
};

export default Radio;
